import React from "react";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceSummary from "./InvoiceSummary";

const InvoiceSummaryPage = ({
    invoice,
    pageNumber,
    totalPages
}) => {

    return (

        <div className="invoice-page">

            <InvoiceHeader invoice={invoice} />

            <div  />

            <InvoiceSummary invoice={invoice} />

        </div>

    );

};

export default InvoiceSummaryPage;